<template>
  <date-range-picker
    class="w-full md:pb-5 pt-0 rounded speakol-date-range-picker"
    ref="picker"
    :locale-data="localData"
    :autoApply="false"
    opens="left"
    @update="onDateChange"
    :ranges="ranges"
    v-model="dates"
    :maxDate="maxDate"
    :minDate="minDate"
    @select="onDateSelected"
    :dateRange="{startDate: null, endDate: null }">

    <template v-slot:input="picker">
      <div>

        <template v-if="picker.startDate">
          <div class="flex items-baseline selected-date pt-1">
            <div class="whitespace-no-wrap">{{ $moment(picker.startDate).format('YYYY-MM-DD') }} -
              {{ $moment(picker.endDate).format('YYYY-MM-DD') }}
            </div>
            <div class="flex w-full justify-end">
              <vs-icon icon-pack="speakol" icon="speakol-calendar"></vs-icon>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="flex items-baseline placeholder pt-1">
            <div class="whitespace-no-wrap">{{ placeholder || 'select date' }}</div>
            <div class="flex w-full justify-end">
              <vs-icon icon-pack="speakol" icon="speakol-calendar"></vs-icon>
            </div>
          </div>

        </template>

      </div>

    </template>

    <div slot="footer" slot-scope="data" class="footer">
      <div class="btns-container md:flex justify-end">
        <div class="text-center my-3 mx-2">
          <span class="range-text">{{ data.rangeText }}</span>
        </div>
        <div class="text-center">
          <button @click="data.clickApply" :disabled="!!data.in_selection" class="text-center btns btn-apply">{{ $t('daterange_picker.apply') }}</button>
          <button @click="handleToggle(data)" class="text-center btns btn-cancel"> {{ $t('daterange_picker.cancel') }}</button>
        </div>
      </div>

      <slot name="actions-footer"></slot>
    </div>
  </date-range-picker>
</template>

<script>
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
//import store from '../store/store'

export default {
  name: 'speakol-date-range-picker',
  props: {
    placeholder: {
      type: String,
      required: false
    },
    dateRange: {
      type: Object,
      required: false,
      default: null
    },
    value: {
      type: Object,
      required: false,
      default: null
    },
    ignoreDefault: {
      type: Boolean,
      required: false,
      default: false
    },
    minimumDate: {
      type: Date,
      required: false,
      default: () => {
        return new Date('2016-01-01')
      }
    }
  },
  data () {
    return {
      maxDate: new Date(),
      minDate: this.minimumDate,
      localData: {
        direction: 'ltr',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        firstDay: 1
      },
      dates: this.dateRange || {
        startDate: this.$moment().subtract(7, 'day'),
        endDate: this.$moment()
      },
      ranges: this.getDatepickerRages()
    }
  },
  created () {
    if (this.value) {
      this.dates = this.value
    }

    if (this.ignoreDefault) {
      this.onDateChange()
      return
    }

    /**
     * This code needs to refactored !!!
     */
    const activeAccount = this.$store.getters['authentication/activeAccount']

    if (!this.dateRange && !this.$can('speakol_dashboard')) {
      this.minDate = new Date(activeAccount.created_at)
      this.minDate.setDate(this.minDate.getDate() - 1)
      this.dates.startDate = new Date(activeAccount.created_at)

      this.dates.endDate = this.maxDate
    } else if (this.dateRange && !this.$can('speakol_dashboard'))  {
      this.minDate = new Date(activeAccount.created_at)
      this.minDate.setDate(this.minDate.getDate() - 1)

      this.dates = this.dateRange

      if (new Date(this.dates.startDate).getTime() < new Date(activeAccount.created_at).getTime()) {
        this.dates.startDate = new Date(activeAccount.created_at)
      }
    }

    this.onDateChange()
  },
  methods: {
    handleToggle (data) {
      this.$emit('closed')
      data.clickCancel()
    },
    // Just when user selected the date range without clicking apply
    onDateSelected (date) {
      this.$emit('date-selected', date)
    },

    getDatepickerRages () {
      const
        today = new Date(),
        yesterday = new Date(),
        last7Days = new Date()

      yesterday.setDate(today.getDate() - 1)
      last7Days.setDate(today.getDate() - 7)

      const minDate = this.$moment(this.minDate ? this.minDate : this.minimumDate).add(1, 'days')
      const lastYear = this.$moment(new Date(new Date().getFullYear() - 1, 0, 1))
      let lastYearStartDate = minDate.isSameOrAfter(lastYear) ? minDate : lastYear
      lastYearStartDate = new Date(lastYearStartDate)

      let full = this.minDate ? this.minDate : this.minimumDate
      full = new Date(this.$moment(full).add(1, 'days'))

      return {
        'Today': [today, today],
        'Yesterday': [yesterday, yesterday],
        'Last 7 days': [last7Days, yesterday],
        'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
        'This month': [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth() + 1, 0)],
        'Last year': [lastYearStartDate, new Date(new Date().getFullYear() - 1, 11, 31)],
        'All': [full, today]
      }
    },
    onDateChange () {
      this.$emit('date-change', this.dates)
      this.$emit('input', this.dates)
    }
  }
}
</script>

<style lang="scss" scoped>

$darkGray: #d9d9d9;
$inputBorder: 1px solid $darkGray;
$dateRangeIcon : #d9d9d9;
$speakolColor: #0092d7;

.range-text {
  font-size: 12px;
}

.speakol-date-range-picker /deep/ .reportrange-text {
  height: 40px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 27px;
  border: $inputBorder;
}

.selected-date {
  color: #2c2c2c;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
}

.placeholder {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.25);
}

.range-picker {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 27px;
}

.speakol-date-range-picker /deep/ .vs-icon {
  font-size: 1rem !important;
  color: $dateRangeIcon;
}

.speakol-date-range-picker /deep/ .vue-daterange-picker {
  border: $inputBorder !important;
  background: #fff !important;
  border-radius: 4px !important;
}

.speakol-date-range-picker /deep/ .calendars {
  flex-direction: row-reverse;
}

.speakol-date-range-picker /deep/ .ranges {
  float: right !important;

  li {
    border: $inputBorder;
    margin-right: 10px;
    padding: 8px 10px !important;
    color: #2c2c2c;
    margin-top: 7px;
    text-align: center;
    border-radius: 3px;
  }

  li.active {
    color: #08c !important;
    background-color: white !important;
    border-radius: 3px;
    border: 1px solid #08c !important;
  }
}

.speakol-date-range-picker /deep/ .table-condensed {
  tbody:first-of-type tr:first-child {
    color: #0092d7;
    font-weight: 500;
  }
}

.speakol-date-range-picker /deep/ .daterangepicker td.active,
.speakol-date-range-picker /deep/ .daterangepicker td.active:hover {
  background-color: #0092d7 !important;
}

.speakol-date-range-picker /deep/ .daterangepicker.show-ranges .drp-calendar.left {
  border-left: none !important;
}

.footer {
  margin-top: 10px;

  .btns-container {
    text-align: right;
    margin-right: 10px;
    margin-bottom: 10px;

    .btns {
      border: 1px solid;
      border-radius: 3px;
      font-size: 14px;
      margin-left: 5px;
      width: 63px;
      height: 32px;
      font-weight: normal;
      cursor: pointer;
    }

    .btn-apply {
      @extend .btns;

      background-color: $speakolColor;
      border: none;
      color: white;
    }

    .btn-cancel {
      @extend .btns;

      background-color: white;
      border: 1px solid $darkGray;
      color: black;
      float: right;
    }
  }
}

@media (max-width: 768px) {
  .btns {
    width: 46% !important;
  }

  .speakol-date-range-picker /deep/ .dropdown-menu {
    max-width: 100% !important;
    overflow-x: auto !important;
    margin-right: -10px;

    .ranges {
      float: none !important !important;

      li {
        margin: 3% !important;
        width: 44%;
        padding: 12px !important;
      }
    }

    .calendars-container {
      display: block;

      .drp-calendar {
        margin: 0 !important;
        padding: 5px !important;
        width: 100% !important;
        float: none !important;
        max-width: 1000px;
      }
    }
  }
}
</style>
